import { render, staticRenderFns } from "./CaseFilesCard.vue?vue&type=template&id=395b2eb2"
import script from "./CaseFilesCard.vue?vue&type=script&lang=js"
export * from "./CaseFilesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports